// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemUnitColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the unit of measure column for item subtables.
// options.size: 'small' (11px, default) | 'middle' (14px)
function itemUnitColumn(options = {}) {
  const { size } = options;
  const fontSize = resolveItemFontSize(size, 11);

  return {
    title: translateX('unit_abbr'),
    dataIndex: 'unit',
    width: 50,
    align: 'center',
    sorter: (a, b) => {
      const aVal = a?.unit || a?.product?.unit || '';
      const bVal = b?.unit || b?.product?.unit || '';
      return aVal.localeCompare(bVal);
    },
    render: (_, item) => (
      <Text style={{ fontSize }}>{item?.unit || item?.product?.unit || '—'}</Text>
    ),
  };
}

export default itemUnitColumn;
